<template>
  <b-card>
    <b-row>
      <!-- Dedicated Fund Info: Left col -->
      <b-col
          cols="12"
          xl="9"
          class="d-flex justify-content-between flex-column"
      >
        <!-- Fund History Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <b-avatar
              :text="avatarText(crName)"
              :variant="`light-${resolveFundHistoryVariant()}`"
              size="104px"
              rounded
          />
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ localBalance }}
                <feather-icon
                    class="cursor-pointer ml-1"
                    :icon="balanceToggleIcon"
                    @click="toggleBalanceVisibility"
                />
              </h4>
              <div>
                <span class="card-text">{{ crName }}</span>
              </div>
            </div>
            <transac-modal @transacUpdated="fetchData" :type="'dedicated-fund'"/>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {BCard, BButton, BAvatar, BRow, BCol} from "bootstrap-vue";
import {avatarText} from "@core/utils/filter";
import Ripple from "vue-ripple-directive";
import TransacModal from "@/components/fund-history/TransacModal.vue";
import {amountToCurrency} from "@/utils/formatAmount";

import {computed, ref, watch} from "@vue/composition-api";
import store from "@/store";
import dedicatedFund from "@/store/modules/dedicated-fund-module";

export default {
  name: "DedicatedFundListDedicatedFundInfoCard",
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,
    TransacModal,
  },
  directives: {
    Ripple,
  },
  props: {
    fetchData: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      showBalance: false,
      showAccountDetails: false,
    };
  },
  setup() {
    const resolveFundHistoryVariant = () => {
      const variants = ["primary", "info", "success"];

      return variants[Math.floor(Math.random() * variants.length)];
    };

    const showAccountDetails = ref(false);
    const showBalance = ref(false);

    watch(showAccountDetails, (isOpened) => {
      if (isOpened) {
        // TODO: ?
      }
    });
    const toggleBalanceVisibility = () =>
        (showBalance.value = !showBalance.value);

    const dedicatedFundDetails = computed(
        () => store.getters["dedicatedFund/dedicatedFundDetails"]
    );

    const crName = computed(() =>
        dedicatedFundDetails.value ? dedicatedFundDetails.value.name : "_____"
    );

    const localBalance = computed(() => {
      if (showBalance.value) {
        const balance = dedicatedFundDetails.value.amount ?? 0;
        return amountToCurrency(balance);
      }
      return "********** FCFA";
    });

    const balanceToggleIcon = computed(() => {
      return showBalance.value ? "EyeIcon" : "EyeOffIcon";
    });

    return {
      localBalance,
      dedicatedFundDetails,
      crName,
      showAccountDetails,

      avatarText,
      balanceToggleIcon,
      toggleBalanceVisibility,
      resolveFundHistoryVariant,
      amountToCurrency,
    };
  },
};
</script>
